import { Modal } from '@mui/material';
import { useContext } from 'react';
import { ViContext } from '../../context/ViContext';
import { setCookie } from '../../common/func/cookieFunc';

export default function Method(props) {
	return (
		<Modal open={props.open} onClose={() => props.setOpen(false)}>
			{/* <!-- 분석방법 모달 팝업 --> */}
			<section className="modalSection" tabIndex="-1">
				<div className="modalPaper">
					<div className="modalHead">
						<div type="button" className="tit">
							<img src="img/headerIcon01.png" alt="icon" />
							세부지표 및 분석 방법
						</div>
						<button
							className="closeIconButton"
							onClick={() => props.setOpen(false)}
						>
							<img src="img/popCloseBtn.png" alt="닫기" />
						</button>
					</div>

					<div className="modalBody">
						<div className="HeadingBox">
							<h2 className="text-heading-mi">지역활력지수 세부지표 구성</h2>
						</div>

						<div className="dataSourceTable indent">
							<table>
								<thead>
									<tr>
										<th rowSpan="2">구분</th>
										<th rowSpan="2">영역</th>
										<th colSpan="2">세부지표</th>
										<th rowSpan="2">지표특성</th>
										<th rowSpan="2">설명</th>
									</tr>
									<tr>
										<th>시군구 단위</th>
										<th>읍면동 단위</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td rowSpan="3">인구 활력</td>
										<td rowSpan="3">인구 활력도</td>
										<td>L1-1 경제활동인구</td>
										<td>L2-1 생산가능인구</td>
										<td>O</td>
										<td>
											- 만15세~64세까지의 인구 중 조사기간 동안 재화나 용역을
											생산하기 위해 노동을 제공할 의사와 능력이 있는 사람
										</td>
									</tr>
									<tr>
										<td>L1-2 학령인구</td>
										<td>L2-1 학령인구</td>
										<td>O</td>
										<td>- 만 6세~21세 인구</td>
									</tr>
									<tr>
										<td>L1-3 체류인구</td>
										<td>-</td>
										<td>△</td>
										<td>
											<p>
												- 통계청 통신모바일 인구이동량 통계(실험적 통계 1호) :
												민간 빅데이터(SKT)를 활용하여 시군구별 관내 및 관외
												인구이동량을 측정한 것으로 매주 단위 작성
											</p>
											<p>- 본 연구에서는 관내+관외 인구를 집계하여 활용</p>
										</td>
									</tr>
									<tr>
										<td rowSpan="7">경제 활력</td>
										<td rowSpan="3">소비 활력도</td>
										<td>L1-4 소매업 및 읍식/주점업 월매출액 합계</td>
										<td>-</td>
										<td>☆</td>
										<td>
											<p>- 사업체가 영업 또는 경상적 활동으로부터 얻는 수익</p>
											<p>- 전국 행정동 단위 KCB 데이터</p>
											<p>
												- 표준산업분류코드 중분류(자동차를 제외한 소매업종,
												음식점 및 주점업) 월매출액 합계(소비활동 추정)
											</p>
										</td>
									</tr>
									<tr>
										<td>L1-5 총수입금액</td>
										<td>L2-3 추정 소득</td>
										<td>△</td>
										<td>
											{`- 시군구 단위는 국세청의 국세통계자료로 개인이 지난해 1년간의 경제활동으로 얻은 총수입금액\n- 읍면동 단위는 KCB에서 추정한 읍면동 단위 기준의 개인총소득월환산금액의 합계`}
										</td>
									</tr>
									<tr>
										<td>L1-6 카드이용금액</td>
										<td>L2-4 카드이용금액</td>
										<td>☆</td>
										<td>- 최근 3개월간 이용한 총카드이용금액의 합계</td>
									</tr>
									<tr>
										<td rowSpan="4">생산 활력도</td>
										<td>L1-7 사업체 매출액</td>
										<td rowSpan="2">
											L2-5 소매업 및 음식/주점업 월매출액 합계
										</td>
										<td rowSpan="2">☆</td>
										<td rowSpan="2">
											<p>
												- 시군구 단위는 통계청이 제공하는
												행정통계(기업통계등록부(2010~2020)) 활용
											</p>
											<p>
												- 읍면동 단위는 KCB의 자동차를 제외한 소매업종, 음식점
												및 주점업의 월매출액 합계액
											</p>
										</td>
									</tr>
									<tr>
										<td style={{ textAlign: 'center' }}>L1-8 사업체 개수</td>
									</tr>
									<tr>
										<td>L1-9 인력수요로 본 일자리 수</td>
										<td>L2-6 인력수요로 본 일자리 수</td>
										<td>☆</td>
										<td>
											<p>
												- 통계청이 워크넷, 인크루트, 사람인 구인정보를 바탕으로
												구인업체수를 집계한 것(통계청 일자리맵)
											</p>
											<p>- 1일 단위 데이터 갱신</p>
										</td>
									</tr>
									<tr>
										<td>L1-10 개인사업자 창업율</td>
										<td>-</td>
										<td>△</td>
										<td>
											<p>- 국세청 국세통계 정보를 바탕으로 산출</p>
											<p>
												- 창업률 : (개인사업자의 신규사업자수 ÷ 가동사업자수) ×
												100
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div
							className="Content"
							style={{ display: 'flex', justifyContent: 'center' }}
						>
							<p>
								※ ☆ 신규개발, △ 기존통계를 가공하여 산출, O 기존통계 활용,
								데이터 구축시점은 지표별 구득 가능한 최신의 데이터로 구축
								<br />※ 읍면동 단위 지표 중 일부는 데이터 구득 한계성 등을
								고려하여 시군구 단위 분석에 활용한 지표의 유사지표로 대체하여
								분석
							</p>
						</div>

						<div className="dotLine"></div>

						<div className="HeadingBox">
							<h2 className="text-heading-mi">지역활력지수 산출방법</h2>
						</div>
						<div className="Content">
							세부지표별 경향이나 특성을 검토한 후, 해당 시군구 및 읍면동이
							전체에서 어떤 위치를 차지하는지를 파악하기 위해 지표별 값을
							표준화. 표준화 점수는 각 지표 변량을 선형표준화 하여 0~100점으로
							변환
							<br />
							세부지표별 표준점수를 바탕으로 ‘인구‘, ‘소비’, ‘생산＇등 3개
							영역에 대한 값을 계산하여, 각 영역별 활력지수를 산출하고
							순위(Rank)를 산정
							<br />
							각 영역별 점수값을 합산하고 동일가중치를 적용하여 평균점수를
							구하여 지역활력지수를 산출
							<br />
							<span style={{ color: 'blue' }}>
								※ 인터랙티브 리포트에서는 사용자가 영역별 가중치를 적용하여
								관심지역에 대한 맞춤형 지역활력지수 분석 가능
							</span>
						</div>
					</div>
				</div>
			</section>
		</Modal>
	);
}
